import React from "react";
import { AlertCircle, CheckCircle } from "lucide-react";
import type { ValidationResult } from "../types";

interface ImportValidationResultsProps {
  validationResult: ValidationResult;
}

export const ImportValidationResults: React.FC<ImportValidationResultsProps> = ({
  validationResult,
}) => {
  return (
    <div className="space-y-6 pt-6 border-t border-slate-100">
      <h3 className="text-[18px] font-bold text-slate-800">Validation Results</h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="bg-[#ECFDF5] border border-[#10B981]/15 p-4 rounded-[12px] flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-[#10B981]/10 flex items-center justify-center text-[#10B981] shrink-0">
              <CheckCircle className="w-5 h-5" />
            </div>
            <div>
              <span className="font-bold text-slate-700 block text-[14px]">Valid Rows</span>
              <span className="text-[12px] text-slate-500 font-medium">Ready to import</span>
            </div>
          </div>
          <p className="text-2xl font-bold text-[#10B981]">
            {validationResult.valid.length}
          </p>
        </div>

        <div className="bg-[#FEF2F2] border border-[#EF4444]/15 p-4 rounded-[12px] flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-[#EF4444]/10 flex items-center justify-center text-[#EF4444] shrink-0">
              <AlertCircle className="w-5 h-5" />
            </div>
            <div>
              <span className="font-bold text-slate-700 block text-[14px]">Invalid Rows</span>
              <span className="text-[12px] text-slate-500 font-medium">Contain format errors</span>
            </div>
          </div>
          <p className="text-2xl font-bold text-[#EF4444]">
            {validationResult.invalid.length}
          </p>
        </div>
      </div>

      {/* Show validation errors detail if any */}
      {validationResult.invalid.length > 0 && (
        <div className="bg-[#FEF2F2] border border-[#EF4444]/15 p-4 rounded-[12px] space-y-2">
          <h4 className="font-bold text-[#EF4444] text-[14px] flex items-center gap-2">
            <AlertCircle className="w-4 h-4" />
            Validation Errors (First 10 rows):
          </h4>
          <div className="space-y-1.5 max-h-40 overflow-y-auto pr-2 scrollbar-thin">
            {validationResult.invalid.slice(0, 10).map((error, index) => (
              <div key={index} className="text-[13px] text-[#EF4444]/90 font-medium">
                <strong>Row {error.row}:</strong> {error.errors.join(', ')}
              </div>
            ))}
            {validationResult.invalid.length > 10 && (
              <p className="text-[12px] text-[#EF4444]/75 italic mt-1 font-semibold">
                ... and {validationResult.invalid.length - 10} more errors
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
